import React from "react";
import { NavLink } from "react-router-dom";
import {
  HiPencilSquare, HiOutlinePencilSquare,
  HiChartBarSquare, HiOutlineChartBarSquare,
  HiArrowRightOnRectangle, HiOutlineArrowRightOnRectangle,
} from "react-icons/hi2";
import { useSessionStatsNav } from "../../contexts/SessionStatsContext";

const sections = [
  { url: "/solve-problem", name: "Zadanie",    overlay: "task",  IconActive: HiPencilSquare,            IconInactive: HiOutlinePencilSquare },
  { url: "/session-stats", name: "Statystyki", overlay: "stats", IconActive: HiChartBarSquare,          IconInactive: HiOutlineChartBarSquare },
  { url: "/end-session-stats", name: "Wystarczy", overlay: null, IconActive: HiArrowRightOnRectangle, IconInactive: HiOutlineArrowRightOnRectangle },
];

const itemClass = (isActive) =>
  `flex flex-col justify-center items-center gap-0.5 w-full h-full rounded-lg transition-colors duration-200
    ${isActive ? "text-[#233855]" : "text-gray-400 hover:text-gray-600"}`;

const NavContent = ({ isActive, IconActive, IconInactive, name }) => {
  const Icon = isActive ? IconActive : IconInactive;
  return (
    <>
      <Icon className="w-6 h-6" />
      <span className="text-xs font-semibold tracking-wide leading-none">{name}</span>
    </>
  );
};

const NavTestPage = () => {
  // Gdy jesteśmy w sesji z overlayem (SolveProblem), Zadanie/Statystyki przełączają
  // overlay bez nawigacji. Poza sesją (context = null) działa klasyczny routing.
  const statsNav = useSessionStatsNav();

  return (
    <div className="w-full h-16 xl:h-[clamp(2rem,10vh,3.9rem)] bg-transparent">
      <ul className="grid grid-cols-3 justify-items-center items-center h-full">
        {sections.map((section) => {
          const useOverlay = statsNav && section.overlay;
          const isActive = useOverlay
            ? (section.overlay === "stats" ? statsNav.isOpen : !statsNav.isOpen)
            : undefined;

          return (
            <li key={section.url} className="w-full h-full">
              {useOverlay ? (
                <button
                  type="button"
                  onClick={() => statsNav.setOpen(section.overlay === "stats")}
                  className={itemClass(isActive)}
                >
                  <NavContent isActive={isActive} {...section} />
                </button>
              ) : (
                <NavLink to={section.url} className={({ isActive }) => itemClass(isActive)}>
                  {({ isActive }) => <NavContent isActive={isActive} {...section} />}
                </NavLink>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NavTestPage;
